import styled from 'styled-components';

const truncateByLines = (lines = 1) => `
		overflow: hidden;
  		display: -webkit-box;
  		-webkit-box-orient: vertical;
  		-webkit-line-clamp: ${lines};
`;

export const StyledTableDefault = styled.div`
  padding: 0 40px;

  table {
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 15px;
    text-align: center;

    thead tr {
      box-shadow: 0 2px 6px rgba(0, 0, 0, .1);
    
      th {
        border: 0;
      }
    }
    
    tr {
      padding: 5px 0;
      
      td {
        vertical-align: middle;
      }
    }
    
    tbody tr td.container-link-google {
      * {
        display: block;
        max-width: 250px;
        text-align: left;
        margin: 0 auto;
      }
      
      a.link-google {
        color: #1a0dab;
        font-size: 18px;
        line-height: 1.33;
       	${truncateByLines(3)}
        
        &:visited {
          color: #609;
        }
      }
      
      cite {
        font-size: 14px;
        padding-top: 1px;
        line-height: 1.43;
        color: #006621;
        font-style: normal;
        display: flex;
        margin: 2px auto;
        
        a {
          color: #006621;
          white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 250px;
          
          .fa-ad {
            color: #ECB931;
          }
        }
        
        * {
          display: inline-block;
          margin: 0 auto;
        }
      }
      
      p {
        font-size: 13px;
        color: #444;
        ${truncateByLines(6)};
      }
    }
  }  
`;
